import { createSlice } from "@reduxjs/toolkit";
import {
  readUserNotification,
  // unreadUserNotification,
  userNotifications,
} from "../services/auth.service";

const initialState = {
  notificationData: [],
  totalNotificationCount: 0,
  currentPage: 1,
  totalPages: '',
  notificationLoader: false,
  error: "",
};
const notificationSlice = createSlice({
  name: "notification",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userNotifications.pending, (state, action) => {
        state.notificationLoader = true;
      })
      .addCase(userNotifications.fulfilled, (state: any, action: any) => {
        state.notificationLoader = false;
        // Extract existing IDs from the current notifications
        const existingIds = new Set(
          state.notificationData.map((item: any) => item.id)
        );

        // Filter out notifications that are already present
        const newNotifications =
          action.payload?.data?.results.filter(
            (item: any) => !existingIds.has(item.id)
          ) || [];

        // Append new notifications while avoiding duplicates
        state.notificationData = [
          ...state.notificationData,
          ...newNotifications,
        ];
        state.totalNotificationCount = action.payload?.data?.count || 0;
        state.currentPage = action.payload?.data?.current_page || 1;
        state.totalPages = action.payload?.data?.total_pages;
      })
      .addCase(userNotifications.rejected, (state, action) => {
        state.notificationLoader = false;
      })
      .addCase(readUserNotification.pending, (state, action) => {
        state.notificationLoader = true;
      })
      .addCase(readUserNotification.fulfilled, (state: any, action: any) => {
        state.notificationLoader = false;
        // Remove the notification from the state
        state.notificationData = state.notificationData.filter(
          (item: any) => item.id !== action.meta.arg
        );
      })
      .addCase(readUserNotification.rejected, (state: any, action) => {
        state.notificationLoader = false;
        state.error = action.error.message;
      });
  },
});

export default notificationSlice.reducer;
